import { ObjUtils, Iterable, IComparable } from "../Utils/ObjUtils";
import { InfoSet } from "../InfoSets/InfoSet";
import { IpAddress, IpVersion } from "../Core/IpAddress";
import { MacAddress } from "../Core/MacAddress";
import { Device } from "../Core/Device";
import { IpPhoneEntry, IpPhoneTable } from "../InfoSets/IpPhoneTable";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";

//export interface IpPhoneInfoJson {
//    mac_address: string;
//    ip_address: string;
//    name: string;
//    description: string;
//    serial_number: string;
//    user_name: string;
//    status: string;
//    time_last_registered: string;
//    e911_location: string;
//    load_id: string;
//    extensions: string;
//    product_type: string;
//    product_category: string;
//  }

  export class IpPhoneInfo extends InfoSet /*implements ISerializable*/ {
    //public static FromJson(json: IpPhoneInfoJson, device: Device): IpPhoneInfo {
    //  var ipPhoneInfo = new IpPhoneInfo(device);
    //  ipPhoneInfo.Deserialize(json);
    //  return ipPhoneInfo;
    //}

    //public Deserialize(json: IpPhoneInfoJson) {
    //  if (json.mac_address !== undefined)
    //    this.MacAddress = MacAddress.CreateFromString(json.mac_address);
    //  if (json.ip_address !== undefined)
    //    this.IpAddress = IpAddress.Create(json.ip_address);
    //  if (json.name !== undefined)
    //    this.Name = json.name;
    //  if (json.description !== undefined)
    //    this.Description = json.description;
    //  if (json.serial_number !== undefined)
    //    this.SerialNumber = json.serial_number;
    //  if (json.user_name !== undefined)
    //    this.UserName = json.user_name;
    //  if (json.status !== undefined)
    //    this.Status = json.status;
    //  if (json.time_last_registered !== undefined)
    //    this.TimeLastRegistered = json.time_last_registered;
    //  if (json.e911_location !== undefined)
    //    this.E911Location = json.e911_location;
    //  if (json.load_id !== undefined)
    //    this.LoadID = json.load_id;
    //  if (json.extensions !== undefined)
    //    this.Extensions = json.extensions;
    //  if (json.product_type !== undefined)
    //    this.ProductType = json.product_type;
    //  if (json.product_category !== undefined)
    //    this.ProductCategory = json.product_category;
    //}

    // ATTRIBUTES
    public MacAddress: MacAddress;
    public get HasMacAddress(): boolean {
      return !!this.MacAddress;
    }

    public IpAddress: IpAddress;
    public get HasIpAddress(): boolean {
      return !!this.IpAddress;
    }

    public Name: string;
    public get HasName(): boolean {
      return !!this.Name;
    }

    public Description: string;
    public get HasDescription(): boolean {
      return !!this.Description;
    }

    public SerialNumber: string;
    public get HasSerialNumber(): boolean {
      return !!this.SerialNumber;
    }

    public UserName: string;
    public get HasUserName(): boolean {
      return !!this.UserName;
    }

    public Status: string;
    public get HasStatus(): boolean {
      return !!this.Status;
    }

    public TimeLastRegistered: string;
    public get HasTimeLastRegistered(): boolean {
      return !!this.TimeLastRegistered;
    }

    public E911Location: string;
    public get HasE911Location(): boolean {
      return !!this.E911Location;
    }

    public LoadID: string;
    public get HasLoadID(): boolean {
      return !!this.LoadID;
    }

    public Extensions: string;
    public get HasExtensions(): boolean {
      return !!this.Extensions;
    }

    public ProductType: string;
    public get HasProductType(): boolean {
      return !!this.ProductType;
    }

    public ProductCategory: string;
    public get HasProductCategory(): boolean {
      return !!this.ProductCategory;
    }

    constructor(device: Device) {
      super(device);
      this.Init();
    }

    private Init(): void {
      this.MacAddress = null;
      this.IpAddress = null;

      this.Name = '';
      this.Description = '';
      this.SerialNumber = '';
      this.UserName = '';

      this.Status = '';
      this.TimeLastRegistered = '';
      this.E911Location = '';
      this.LoadID = '';
      this.Extensions = '';

      this.ProductType = '';
      this.ProductCategory = '';
    }

    public Copy(ipPhoneEntry: IpPhoneEntry): void {
      if (ipPhoneEntry == null)
        return;

      if (ipPhoneEntry.HasMacAddress)
        this.MacAddress = ipPhoneEntry.MacAddress.Clone();

      if (ipPhoneEntry.HasIpAddress)
        this.IpAddress = ipPhoneEntry.IpAddress.Clone();

      if (ipPhoneEntry.HasName)
        this.Name = ipPhoneEntry.Name + '';

      if (ipPhoneEntry.HasDescription)
        this.Description = ipPhoneEntry.Description + '';

      if (ipPhoneEntry.HasSerialNumber)
        this.SerialNumber = ipPhoneEntry.SerialNumber + '';

      if (ipPhoneEntry.HasUserName)
        this.UserName = ipPhoneEntry.UserName + '';

      if (ipPhoneEntry.HasStatus)
        this.Status = ipPhoneEntry.Status + '';

      if (ipPhoneEntry.HasTimeLastRegistered)
        this.TimeLastRegistered = ipPhoneEntry.TimeLastRegistered + '';

      if (ipPhoneEntry.HasE911Location)
        this.E911Location = ipPhoneEntry.E911Location + '';

      if (ipPhoneEntry.HasLoadID)
        this.LoadID = ipPhoneEntry.LoadID + '';

      if (ipPhoneEntry.HasExtensions)
        this.Extensions = ipPhoneEntry.Extensions + '';

      if (ipPhoneEntry.HasProductTypeToString)
        this.ProductType = ipPhoneEntry.ProductTypeToString + '';

      if (ipPhoneEntry.HasProductCategoryToString)
        this.ProductCategory = ipPhoneEntry.ProductCategoryToString + '';
    }

	public Write(obj: any, context: any): void {
		obj.ip_phone_info = {};
		obj = obj.ip_phone_info;

		if (this.HasMacAddress)
			obj.mac_address = ValueEncoder.EncodeMacAddress(this.MacAddress);

		if (this.HasIpAddress)
			obj.ip_address = ValueEncoder.EncodeIpAddress(this.IpAddress);

		if (this.HasName)
			obj.name = this.Name;

		if (this.HasDescription)
			obj.description = this.Description;

		if (this.HasSerialNumber)
			obj.serial_number = this.SerialNumber;

		if (this.HasUserName)
			obj.user_name = this.UserName;

		if (this.HasStatus)
			obj.status = this.Status;

		if (this.HasTimeLastRegistered)
			obj.time_last_registered = this.TimeLastRegistered;

		if (this.HasE911Location)
			obj.e911_location = this.E911Location;

		if (this.HasLoadID)
			obj.load_id = this.LoadID;

		if (this.HasExtensions)
			obj.extensions = this.Extensions;

		if (this.HasProductType)
			obj.product_type = this.ProductType;

		if (this.HasProductCategory)
			obj.product_category = this.ProductCategory;
	}

	public Read(obj: any, context: any): void {
		if (!obj.ip_phone_info)
			throw new Error();
		obj = obj.ip_phone_info;

		if (obj.mac_address !== undefined)
			this.MacAddress = ValueEncoder.DecodeMacAddress(obj.mac_address);

		if (obj.ip_address !== undefined)
			this.IpAddress = ValueEncoder.DecodeIpAddress(obj.ip_address);

		if (obj.name !== undefined)
			this.Name = obj.name;

		if (obj.description !== undefined)
			this.Description = obj.description;

		if (obj.serial_number !== undefined)
			this.SerialNumber = obj.serial_number;

		if (obj.user_name !== undefined)
			this.UserName = obj.user_name;

		if (obj.status !== undefined)
			this.Status = obj.status;

		if (obj.time_last_registered !== undefined)
			this.TimeLastRegistered = obj.time_last_registered;

		if (obj.e911_location !== undefined)
			this.E911Location = obj.e911_location;

		if (obj.load_id !== undefined)
			this.LoadID = obj.load_id;

		if (obj.extensions !== undefined)
			this.Extensions = obj.extensions;

		if (obj.product_type !== undefined)
			this.ProductType = obj.product_type;

		if (obj.product_category !== undefined)
			this.ProductCategory = obj.product_category;
	}
  }
